import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import linkToCodeEditor from 'toxilibs/link_to_code_editor.js'
import findProgressionsFor from '../find_progressions_for.js'
import developmentEnvironment from '../development_environment.js'

if (developmentEnvironment) {

    globalEventBus.on('challenge loaded', function (challengeData) {
        $('#challenge_data').html(
            '<a href="' + linkToCodeEditor.url('scripts/challenges/' + challengeData.id + '.js') + '">' + challengeData.id + '</a> (debug)'

        )

        let progressionNames = findProgressionsFor(challengeData.id)
        progressionNames.forEach((name) => {
            $('#challenge_data').append('<a class="progression_for_challenge" href="?progression=' + name + '">' + name + '</a>')
        })


        addStatsLink(challengeData)

    })

    globalEventBus.on('step completed', function () {
        $('#challenge_data').html('')
    })
}


globalEventBus.on('stats data loaded', displayWinRatio)



function addStatsLink (challengeData) {
    $('#challenge_data').append('<br><span class="win_ratio">Stats</span>')
    $('.win_ratio').on('click', () => globalEventBus.emit('challenge stats data wanted', challengeData.id))
}


function displayWinRatio ({ratio}) {
    $('.win_ratio').html('Win ratio : ' + (Math.round(ratio * 1000) / 10) + '%')
}

